import React from "react";
import { ContextProviderComposer } from "../utils/ContextProvider";
import { WhatsappToUserProvider } from "../contexts/WhatsappToUserContext";
import { DialogProvider } from "../contexts/DialogContext";

export const WhatsappToUserComposer = ({ children }) => {
  return (
    <ContextProviderComposer
      contextProviders={[<WhatsappToUserProvider key={0} />, <DialogProvider key={1} />]}
    >
      {children}
    </ContextProviderComposer>
  );
};

export default WhatsappToUserComposer;
